import React, { type ReactElement } from 'react'
import { Typography } from '@mui/material'

import { useAppSelector } from '../../../../store/hooks'

import styles from './Answers.module.scss'

const Answers: React.FC = (): ReactElement => {
  const { aiResults } = useAppSelector((state) => state.vendorList)

  return (
    <div className={styles.container}>
      {aiResults[0]?.questions?.map((question, index) => (
        <div key={question.id} className={styles.questionContainer}>
          <Typography variant={'title1'}>
            {index + 1}. {question.question}
          </Typography>
          <Typography variant={'title2'}>{question.answer.text}</Typography>
        </div>
      ))}
    </div>
  )
}

export default Answers
